"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addPrevNextBtnsClickHandlers = void 0;
var addTogglePrevNextBtnsActive = function (emblaApi, prevBtn, nextBtn) {
    var togglePrevNextBtnsState = function () {
        if (emblaApi.canScrollPrev())
            prevBtn === null || prevBtn === void 0 ? void 0 : prevBtn.removeAttribute("disabled");
        else
            prevBtn === null || prevBtn === void 0 ? void 0 : prevBtn.setAttribute("disabled", "disabled");
        if (emblaApi.canScrollNext())
            nextBtn === null || nextBtn === void 0 ? void 0 : nextBtn.removeAttribute("disabled");
        else
            nextBtn === null || nextBtn === void 0 ? void 0 : nextBtn.setAttribute("disabled", "disabled");
    };
    emblaApi
        .on("select", togglePrevNextBtnsState)
        .on("init", togglePrevNextBtnsState)
        .on("reInit", togglePrevNextBtnsState);
    return function () {
        prevBtn === null || prevBtn === void 0 ? void 0 : prevBtn.removeAttribute("disabled");
        nextBtn === null || nextBtn === void 0 ? void 0 : nextBtn.removeAttribute("disabled");
    };
};
exports.addPrevNextBtnsClickHandlers = function (emblaApi, prevBtn, nextBtn) {
    var scrollPrev = function () {
        emblaApi.scrollPrev();
    };
    var scrollNext = function () {
        emblaApi.scrollNext();
    };
    prevBtn === null || prevBtn === void 0 ? void 0 : prevBtn.addEventListener("click", scrollPrev, false);
    nextBtn === null || nextBtn === void 0 ? void 0 : nextBtn.addEventListener("click", scrollNext, false);
    var removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(emblaApi, prevBtn, nextBtn);
    return function () {
        removeTogglePrevNextBtnsActive();
        prevBtn === null || prevBtn === void 0 ? void 0 : prevBtn.removeEventListener("click", scrollPrev, false);
        nextBtn === null || nextBtn === void 0 ? void 0 : nextBtn.removeEventListener("click", scrollNext, false);
    };
};
